import * as React from "react";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import StatCard from "./StatCard";
import { fetchUserStatistics } from "../../../methods/statistics/statistics";
import StripeFinancialDashboard from "./StripeDashboard";
import DashboardAgendaPanel from "./DashboardAgendaPanel";
import DashboardContractPaymentsPanel from "./DashboardContractPaymentsPanel";
import { useSelector } from "react-redux";

export default function MainGrid() {
  const auth = useSelector((state) => state.user);
  const canViewPaymentsPlugin = ["ADMIN", "EMPLOYEE"].includes(String(auth?.user?.role || ""));
  const [widgetData, setWidgetData] = React.useState([]);
  const hasFetched = React.useRef(false); // Prevent duplicate API calls

  React.useEffect(() => {
    getUserStatistics();
    hasFetched.current = true; // Mark as fetched
  }, []);

  const getUserStatistics = async () => {
    try {
      const response = await fetchUserStatistics();

      if (response.success) {
        const newData = response.data;

        setWidgetData((prevData) => {
          const existingIndex = prevData.findIndex(
            (item) => item.title === newData.title
          );

          if (existingIndex !== -1) {
            // ✅ If title exists, replace it
            const updatedData = [...prevData];
            updatedData[existingIndex] = newData;
            return updatedData;
          } else {
            // ✅ If title does not exist, add it
            return [...prevData, newData];
          }
        });
      }
    } catch (error) {
      console.error("Error fetching user statistics:", error);
    }
  };
  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      {/* cards */}
      <StripeFinancialDashboard />
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Overview
      </Typography>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {widgetData &&
          widgetData.map((card, index) => (
            <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
              <StatCard {...card} />
            </Grid>
          ))}
      </Grid>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Details
      </Typography>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <DashboardAgendaPanel />
        </Grid>
        {canViewPaymentsPlugin ? (
          <Grid size={{ xs: 12, lg: 6 }}>
            <DashboardContractPaymentsPanel />
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
}
